import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { DefaultProductList } from '@catalog/const';
import { ProductListFacade } from '@catalog/data-access';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ProductListComponentService } from '@catalog/feature';
import { RouterState, RoutingService } from '@spartacus/core';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomSearchBoxService } from './custom-searchbox.service';

@Injectable({ providedIn: 'root' })
export class ProductListSmartFoundService {
  constructor(
    private productListFacade: ProductListFacade,
    private productListComponentService: ProductListComponentService,
    private customSearchBoxService: CustomSearchBoxService,
    private routingService: RoutingService,
  ) {}

  getFreeTextSearch(): Observable<string> {
    return this.productListComponentService.model$.pipe(map(({ freeTextSearch }) => freeTextSearch));
  }

  getUserQuerySearch(): Observable<string> {
    return this.customSearchBoxService.getCurrentQuery();
  }

  getTotalResults(): Observable<number> {
    return this.productListComponentService.model$.pipe(map(({ pagination }) => pagination?.totalResults));
  }

  getCorrectedQueryParams(): Observable<Params> {
    return this.productListComponentService.model$.pipe(
      map((searchPage) => {
        return {
          ...searchPage.currentQuery.query,
          freeTextSearch: searchPage.freeTextSearch,
        };
      }),
    );
  }

  isSmartSearchEnabled(): Observable<boolean> {
    const isSearchPage$ = this.routingService
      .getRouterState()
      .pipe(
        map(
          (routerState: RouterState) => routerState.state.semanticRoute === DefaultProductList.SearchResultsProductList,
        ),
      );

    return combineLatest({
      isSearchPage: isSearchPage$,
      freeTextSearch: this.getFreeTextSearch(),
      userQuerySearch: this.getUserQuerySearch(),
      totalResults: this.getTotalResults(),
      loading: this.productListFacade.getLoading(),
    }).pipe(
      map(
        ({ isSearchPage, freeTextSearch, userQuerySearch, totalResults, loading }) =>
          !loading && isSearchPage && freeTextSearch !== userQuerySearch && totalResults > 0,
      ),
    );
  }
}
